/**
 * @generated SignedSource<<7d281dfa619600bfff6799b8f414ce43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditorForm_cateringOption$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CateringOptionName_cateringOption">;
  readonly " $fragmentType": "RoomRatesTableRateEditorForm_cateringOption";
};
export type RoomRatesTableRateEditorForm_cateringOption$key = {
  readonly " $data"?: RoomRatesTableRateEditorForm_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditorForm_cateringOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CateringOptionName_cateringOption"
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "74c70be7ea8b54a8d1b1c1a5153f39a3";

export default node;
